/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from 'lorastyles/base.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  title: React.PropTypes.string,
  description: React.PropTypes.string,
};

class PageError extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      description: props.description,
    };
    this.intlMsg = new IntlMsg(props.intl, 'lora.pageerror');
  }

  componentWillReceiveProps(nextProps) {
    const { title, description } = nextProps;
    if (title !== this.props.title) {
      this.setState({ title });
    }
    if (description !== this.props.description) {
      this.setState({ description });
    }
  }

  render() {
    let { title, description } = this.state;
    if (!title) {
      title = this.intlMsg.msg('default.title');
    }
    if (!description) {
      description = this.intlMsg.msg('default.description');
    }

    return (
      <div className={styles.error}>
        <h5><i className="fa fa-exclamation-triangle" /></h5>
        <h5>{title}</h5>
        <p>{description}</p>
      </div>
    );
  }
}


PageError.propTypes = propTypes;

export default injectIntl(PageError);




// WEBPACK FOOTER //
// ./src/components/PageError.jsx